import axios from 'axios'
import useSWR from 'swr'
import { Project, ProjectType } from '@/components/Projects/Projects'

interface PropertyResponse {
  id: number
  title: string
  imageUrl: string | null
  location: string
  excerpt: string
  description: string
  status: string
  type: string
  propertyType: string
  createdAt: string
  updatedAt: string
}

interface APIResponse {
  success: boolean
  data: PropertyResponse[]
  pagination: {
    page: number
    limit: number
    totalProperties: number
    totalPages: number
  }
}

// Custom fetcher function using axios
const axiosFetcher = async (url: string) => {
  const response = await axios.get<APIResponse>(url)
  return response.data
}

// Helper function to map property types to ProjectType
const mapPropertyType = (propertyType: string): ProjectType => {
  if (propertyType.toLowerCase() === 'residence') return 'Residence'
  if (propertyType.toLowerCase() === 'commercial') return 'Commercial'
  return 'Apartments'
}

export function useProjects() {
  const { data, error, isLoading } = useSWR<APIResponse, Error>(
    'https://api.ipdcgroup.com/property',
    axiosFetcher,
  )

  // Transform API response to match Project interface
  const projects: Project[] =
    data?.data.map((property) => ({
      id: property.id,
      image:
        property.imageUrl ||
        `/project-placeholder-${(property.id % 3) + 1}.jpg`,
      title: property.title,
      location: property.location,
      type: mapPropertyType(property.propertyType),
    })) || []

  return {
    projects,
    pagination: data?.pagination,
    isLoading,
    isError: error,
  }
}
